import React from 'react'
import ReactDOM from 'react-dom/client'
import {RouterProvider} from 'react-router-dom'
import {Provider} from 'react-redux'
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {LocalizationProvider} from '@mui/x-date-pickers'
import {PersistGate} from 'redux-persist/integration/react'
import {HelmetProvider} from 'react-helmet-async'
import reportWebVitals from './reportWebVitals'
import {router} from './app/routes/routes'
import {persistor, store} from './app/setup/redux'
import {CssBaseline, ThemeProvider} from '@mui/material'
import {theme} from './app/setup/mui/theme'
import {setupAxios} from './app/setup/axios'
import {AlertContainer} from './app/modules/common/components/alerts/AlertContainer'

setupAxios(store)
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <RouterProvider router={router} />
              <AlertContainer />
            </PersistGate>
          </Provider>
          <CssBaseline />
        </ThemeProvider>
      </LocalizationProvider>
    </HelmetProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
